import { Routes, useLocation, Route, Outlet } from 'react-router-dom';

import AssetList from '../assetList/AllAssets';
import AssetDetails from '../assetDetail/index';
import { AssetsProvider } from '../context/assetContext';

function AssetRouter() {
  let { pathname } = useLocation();
  console.log(pathname,"HEREEEEEEE for AssetDetails")

  return (
    <AssetsProvider>
    <Routes>
       <Route path="/" element={<Outlet />}>   
       <Route index element={<AssetList />} />      {/*  Matches `/assets` */}
       <Route path=":id" element={<AssetDetails />} />  {/* Matches `/assets/:id` */}
      </Route>
    </Routes>
    </AssetsProvider>
  );
}

export default AssetRouter;
